import { getValueFromSearchParam } from '../utils/url';
import { AmbassadorBulkUpdate } from '../api/schemas/bulkUpdate';
import { SpaceBetween } from '@amzn/awsui-components-react';
import Container from '@amzn/awsui-components-react/polaris/container';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { AmbassadorBulkUpdateDisplay } from '../components/ambassadors/ambassadorBulkUpdateDisplay';
import { AmbassadorBulkUpdateForm } from '../components/ambassadors/ambassadorBulkUpdateForm';
import { featureIsEnabled, useFeatures } from '../hooks/features';
import { COMMUNITY_AMBASSADOR_FEATURE_FLAG } from '../utils/constants';

export function AmbassadorBulkUpdator() {
  const [searchParams] = useSearchParams();
  const filename = getValueFromSearchParam(searchParams, 'filename');
  const { t } = useTranslation(['ambassadors', 'translation']);

  const placeholderAmbassadorBulkUpdate: AmbassadorBulkUpdate = {
    completed: true,
    result: {
      num_added: 13,
      num_updated: 14,
      num_skipped: 15,
    },
  };

  const fileHasBeenSubmitted = filename !== '';

  return (
    <Container fitHeight variant="stacked">
      <h1>{t('bulkUpdate.ambassadors.title')}</h1>
      <SpaceBetween direction="vertical" size="m">
        {fileHasBeenSubmitted ? (
          <AmbassadorBulkUpdateDisplay update={placeholderAmbassadorBulkUpdate} />
        ) : (
          <AmbassadorBulkUpdateForm />
        )}
      </SpaceBetween>
    </Container>
  );
}

export function AmbassadorBulkUpdateView() {
  const features = useFeatures();
  const [searchParams] = useSearchParams();

  if (featureIsEnabled(COMMUNITY_AMBASSADOR_FEATURE_FLAG, features, searchParams)) {
    return <AmbassadorBulkUpdator />;
  }
  return <></>;
}
